import classNames from 'classnames'
import { ReactElement, useEffect, useState } from 'react'
import { useField } from 'remix-validated-form'
import FormInputWrapper, { FormInputWrapperProps } from './FormInputWrapper'

export type FormRadioGroupProps = {
  disabled?: boolean
  readOnlyAsLabel?: boolean
  labelClassName?: string
  errorClassName?: string
  icon?: React.ReactElement
  values: { value: string; label: string }[]
  onChange?: (value: string) => void
} & FormInputWrapperProps<HTMLInputElement>

export function FormRadioGroup({
  name,
  label,
  error,
  disabled,
  readOnlyAsLabel,
  className,
  showErrorIcon,
  icon,
  newLineError,
  cols,
  wrapperClassName,
  labelClassName,
  errorClassName,
  values,
  defaultValue,
  onChange,
  ...props
}: FormRadioGroupProps): ReactElement {
  const { error: err } = useField(name)
  const [value, setValue] = useState<string | number | readonly string[] | undefined>(defaultValue)
  useEffect(() => setValue(defaultValue), [defaultValue])
  return (
    <FormInputWrapper
      {...{
        name,
        label,
        error: err ?? error,
        showErrorIcon,
        newLineError,
        cols,
        wrapperClassName,
        className: labelClassName ?? `text-ui-sm`,
        errorClassName,
        infoTooltip: props.infoTooltip,
      }}
    >
      <fieldset className="flex items-center space-x-3">
        {values.map((v) => (
          <label
            key={v.value}
            className={classNames(
              `flex w-full grow-0 cursor-pointer items-center space-x-1.5 bg-surface ${
                disabled ? `cursor-not-allowed` : ``
              }`,
              className,
            )}
          >
            <input
              name={name}
              type="radio"
              value={v.value}
              className={`cursor-pointer checked:bg-blue-600 hover:checked:bg-blue-600 focus:checked:bg-blue-600 disabled:cursor-not-allowed disabled:bg-surface disabled:checked:bg-(--fg-subtle)`}
              checked={v.value === value}
              onChange={() => {
                setValue(v.value)
                onChange?.(v.value)
              }}
              disabled={disabled}
            />
            <span>{v.label}</span>
          </label>
        ))}
      </fieldset>
    </FormInputWrapper>
  )
}
